<template>
  <div class="divider">
    <div
      :style="{
        height: vertical ? '100%' : `${thickness}px`,
        width: !vertical ? '100%' : `${thickness}px`,
      }"
      class="divider__line"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    thickness: {
      type: Number,
      default: 1,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.divider {
  flex: 1;

  &__line {
    background-color: #eeeeee;
  }
}
</style>
